export default {
  headers: {
    title: 'Lista de faturas de terceiros por despesas reembolsadas',
    created: 'Data de criação',
    id: 'Série - Número',
    provider: 'Fornecedor',
    status: 'Estado',
    type: 'Tipo',
    serie: 'Série',
    number: 'Número',
    amount: 'Valor'
  },
  search: {
    title: 'Buscador'
  },
  filter: {
    byCreated: 'Data de criação',
    byEmited: 'Data de emissão',
    from: 'De',
    to: 'Até',
    byId: 'Série e número',
    bySerie: 'Série',
    byNumber: 'Número',
    byStatus: 'Estado',
    byProviderDocument: 'NIF/CIF/NIE Fornecedor',
    byAmount: 'Valor (€)'
  },
  delete: {
    confirmDeleteTitle: 'Eliminar fatura de terceiros selecionada',
    question: 'Tem certeza de que deseja eliminar a fatura de terceiros selecionada?'
  },
  send: {
    invoice: 'Enviar fatura',
    invoices: 'Enviar faturas'
  }
}